import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import Loader from './../../shared/loader'
import CryptoJS from 'crypto-js';
import csvHelper from '../importCSVHelper';
import download from 'downloadjs';
import moment from 'moment';

import {
	Validator
} from 'vee-validate'
export default {
	name: 'importRackId',
	components: {
		Loader,
		download
	},
	data: function() {
		return {
			file: '',
			error_message: '',
			success_message: '',
			failed_messge: '',
			failed_seen: false,
			error_seen: false,
			success_seen: false,
			csv_config: [],
			rejectedList: [],
			acceptedList: [],
			updatedList: [],
			isLoading: false,
			listDataCsv: [],
			csvFields: [],
			user_type: '',
			useremail: '',
			client: '',
			clientid: '',
			listClientData: [],
			showSelectClient: false,
			ClientErr: '',
			warehouse: '',
			listWarehouseData: [],
			warehouseid: '',
			checkuserforclientlist: 0,
			checkuserforwarehouselist: 0,
			checkifwarehouseselected: 0,
			resetcheck: 0,
			subinventory: 0,
			clientarr : {}
		}
	},
	created: function() {},
	mounted() {
		this.resetcheck = 0;
		var userdetailEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.user_type = userdetail.utype;
		this.useremail = userdetail.email;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.getClientList(1)
		switch (this.user_type) {
			case 'system_user':
				this.resetcheck = 1;
				//this.showSelectClient = true;
				this.clientid = window.localStorage.getItem('selectedClient');
				this.checkuserforclientlist = 1;
				this.checkuserforwarehouselist = 1;
				//  this.getClientList();
				// this.getWarehouseList();
				break;

			case 'warehouse_user':
				//	this.showSelectClient = true;
				this.checkifwarehouseselected = 1;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.clientid = window.localStorage.getItem('selectedClient');
				//  this.getClientList();
				break;

			case 'client_user':
				this.resetcheck = 1;
				this.checkuserforwarehouselist = 1;
				this.clientid = userdetail.clientid;
				// this.getWarehouseList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	},
	methods: {
		saveSubInventory() {
			if (this.subinventory == 1) {
				this.showSelectClient = true;
				this.getClientList(1);
			} else {
				this.client = null;
				this.showSelectClient = false;
			}
		},
		getClientList(str) {
			if (window.localStorage.getItem("clientList") !== null && str == '') {
				var clientListEncrypt = window.localStorage.getItem('clientList');
				var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
				var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
				this.listClientData = JSON.parse(plaintextclient);
			} else {
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				this.input = ({
					warehouseid: window.localStorage.getItem('selectedWarehouse'),
				});
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then(result => {
						this.listClientData = result.data.data;
						this.client = '';
						if (this.listClientData.length > 0) {
							for (let item in this.listClientData) {
								this.clientarr[this.listClientData[item].clientid] = this.listClientData[item].clientname;
							}
						} else {
							this.clientarr = {};
						}
					}, error => {
						console.error(error);
					});
			}
		},
		// clientSelected() {
		// 	this.clientid = this.client;
			
		// },
		clientname(){
			this.client = window.localStorage.getItem("selectedClient")
			this.subInvMsg = this.$t('productLogReport.rackPrefixMsg');
			// console.log(this.listClientData);
			// console.log(this.clientarr);
			return this.clientarr[this.client]
		},
		submitFile() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (this.file == '' || (this.$refs.file.files[0].type != 'text/csv' && this.$refs.file.files[0].type != 'application/vnd.ms-excel')) {
				let uploadFileExtension = this.$refs.file.files[0];
				if (/\.(csv|ms-excel|CSV)$/i.test(uploadFileExtension.name)) {
					//do nothing
					console.log(uploadFileExtension.name, "=====================Valid Extension====================");
				} else {
					this.$alertify.error(this.$t('productLogReport.selectCSVFile'));
					return false;
					console.log(uploadFileExtension.name, "=====================InValid Extension====================");
				}
			}

			console.log(this.clientid,"-------")
			if (!this.clientid && this.subinventory == 1) {
				this.ClientErr = this.$t('srReport.clientError');
				return false;
			}
			this.isLoading = true;
			if (document.getElementById('downloadBtn0'))
				document.getElementById('downloadBtn0').disabled = false;
			if (document.getElementById('downloadBtn1'))
				document.getElementById('downloadBtn1').disabled = false;
			if (document.getElementById('downloadBtn2'))
				document.getElementById('downloadBtn2').disabled = false;
			var formData = new FormData();

			formData.append('csv', this.file);
			formData.append('warehouseid', window.localStorage.getItem('selectedWarehouse'));
			formData.append('useremail', this.useremail);
			if (this.subinventory == 1) {
				formData.append('clientid', this.clientid);
			}

			axios.post(apiUrl.api_url + 'uploadRacksWarehouseWise',
					formData, {
						headers: {
							'Authorization': 'Bearer ' + myStr,
							'Content-Type': 'multipart/form-data'
						}
					})
				.then((response) => {
					this.file = ''
					document.getElementById('file').value = '';
					response = response.data.data[0];
					if (response.status == true) {
						this.error_message = '';
						this.failed_messge = '';
						this.csv_config = response.data.csv_config;
						if(response.data.total_items_created.length > 0){
							this.success_seen = true;
							this.failed_seen = false;
							this.error_seen = false;
						  this.success_message = response.data.total_items_created.length + " Rack's added successfully";
					}
					if(response.data.total_items_updated.length > 0){
					 	this.success_seen = false;
						this.failed_seen = false;
						this.error_seen = true;
						this.error_message = response.data.total_items_updated.length + " Rack's updated successfully";
					}
					if(response.data.total_items_rejected.length > 0){
						this.failed_seen = true;
						this.error_seen = false;
						this.success_seen = false;
					  this.failed_messge = response.data.total_items_rejected.length + " Rack's updation failed";
			  	}
						//  this.rejectedList = response.data.total_items_updated;
						this.rejectedList = response.data.total_items_rejected;
						this.acceptedList = response.data.total_items_created;
						this.updatedList = response.data.total_items_updated;


					} else {
						this.error_seen = true;
						this.success_seen = false;
						this.error_message = response.msg;
						this.success_message = '';
					}
					this.isLoading = false;
				})
				.catch(function() {
					this.error_seen = true;
					this.success_seen = false;
					this.error_message = this.$t(productLogReport.fileUploadErr);
					this.success_message = '';
					this.isLoading = false;
				});
		},
		downloadCSV(str) {
			document.getElementById('downloadBtn' + str).disabled = true;
			this.isLoading = true;
			var csvName = '';
			var showracks = [];
			if (str == '0') {
				showracks = this.acceptedList;
				csvName = 'createdRacks'
			} else if (str == '1') {
				showracks = this.updatedList;
				csvName = 'updatedRacks'
			} else if (str == '2') {
				showracks = this.rejectedList;
				csvName = 'failureRacks'
			}

			if (showracks.length > 0) {
				let csvFields = [];
				let csvArr = [];

				this.csv_config.forEach(function(field) {
					csvArr.push(field.db_col_name);
					csvFields.push({
						'fieldIndex': field.csv_col_name,
						'fieldColumn': field.db_col_name,
						'fieldName': field.csv_col_title
					});
				},this);
				// Add last column for reason
				csvArr.push("failure_reason");
				csvFields.push({
					'fieldIndex': csvFields.length - 1,
					'fieldColumn': "failure_reason",
					'fieldName': this.$t(`importCsv.${'failurereason'}`)
				})

				var dateFilder = [];
				var skipFilter = [];
				var csvResult = [];

				showracks.forEach(function(item) {
					var rowData = [];
					for (let i = 0; i < csvArr.length; i++) {
						if (item[csvArr[i]])
							rowData[csvArr[i]] = item[csvArr[i]]
						else
							rowData[csvArr[i]] = ''
					}
					csvResult.push(rowData);
				});

				csvHelper.data.jsonToCSV(csvName, csvResult, csvFields, dateFilder, skipFilter);
				this.isLoading = false;
			}
		},

		downloadTemplate() {
			if(window.localStorage.getItem('selectedWarehouse')==='undefined'){
				this.$alertify.error(this.$t('common.warehouseError'))
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRackCreationTemplete',
					'data': {
						'warehouseid': window.localStorage.getItem('selectedWarehouse'),
						'type': 'racks'
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((result) => {
					if (result.data.data[0].status) {
						let templateResult = [];
						result.data.data[0].data.forEach(function(field) {
							templateResult.push({
								'fieldIndex': field.csv_col_name,
								'fieldColumn': field.db_col_name,
								'fieldName': this.$t(`importCsv.${field.db_col_name}`)
							});
						},this);
						this.jsonToCSV(this.$t('importCsv.rackIdTemplate'), [], templateResult, [], []);
					} else {
						this.$alertify.error(result.data.data[0].msg);
						return false;
					}
				})
		},
		jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
			//  var data = this.listStockReportData;
			var csvData = ''
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			//Fields Names
			csvfield.forEach(function(fields) {
				if (skipFilter.indexOf(fields.fieldColumn) == -1) {
					csvData += fields.fieldName + ','
				}
			});

			csvData = csvData.slice(0, csvData.length - 1)
			csvData += '\r\n'
			// CSV Data
			data.map(function(item) {
				var i = 0;
				var escapedCSV = ''
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						escapedCSV = item[key] + '' // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilder.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ','
							else
								csvData += escapedCSV + ','
						}
					}
					i++;
				}
				csvData = csvData.slice(0, csvData.length - 1)
				csvData += '\r\n'
			})
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n')
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData
		},
		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		resetFrom() {
			document.getElementById('file').value = '';
			this.error_seen = false;
			this.success_seen = false;
			this.rejectedList = [];
			this.failed_seen = false;
			this.failed_messge = ''
			this.file = ''
			// this.client = '';
			// this.clientid = '';
			// this.warehouse = '';
			if (this.resetcheck == 1) {
				this.checkifwarehouseselected = 0;
			}


		},
		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;
		// 		this.input = ({
		// 			'clientid': this.clientid,
		// 		});
		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}

		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	if (this.warehouseid != '') {
		// 		this.checkifwarehouseselected = 1;
		// 	}
		// 	if (this.subinventory == 1) {
		// 		this.showSelectClient = true;
		// 		this.getClientList(1);
		// 	}
		// },

		handleFileUpload() {
			this.file = this.$refs.file.files[0];

		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/importCSV/importRackID/importRackID.component.js